export default __webpack_public_path__ + "static/media/Abouts.34675d20.png";